import { render, staticRenderFns } from "./UserWindowView.vue?vue&type=template&id=51e2a21a&scoped=true&"
import script from "./UserWindowView.vue?vue&type=script&lang=js&"
export * from "./UserWindowView.vue?vue&type=script&lang=js&"
import style0 from "./UserWindowView.vue?vue&type=style&index=0&id=51e2a21a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e2a21a",
  null
  
)

export default component.exports